import { gql } from '@apollo/client';

import { useOrgSlugQuery } from 'src/generated/mloop-graphql';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const OrgSlugQuery = gql`
  query OrgSlug {
    thisOrg {
      id
      slugs {
        id: orgId
        slug
      }
    }
  }
`;

const useOrgSlug = (skip?: boolean) => {
  const { data, ...rest } = useOrgSlugQuery({
    skip,
  });
  return { orgSlug: data?.thisOrg?.slugs?.[0]?.slug, ...rest };
};

export default useOrgSlug;
